import React from "react";
import { TextField, Autocomplete } from "@mui/material";

type Props = {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  sx?: any;
  options?: string[];
  fontSize?: string | number;
  isDisabled?: boolean;
};

const DeliveryUnitSelect: React.FC<Props> = ({
  value,
  onChange,
  label = "納品単位",
  sx,
  options = ["C/S", "本", "袋", "個", "箱", "枚"],
  fontSize = "0.9rem",
  isDisabled = false,
}) => {
  return (
    <Autocomplete
      freeSolo
      options={options}
      value={value}
      sx={sx}
      fullWidth
      onChange={(_, newValue) => {
        onChange(newValue || "");
      }}
      onInputChange={(_, newInputValue) => {
        onChange(newInputValue);
      }}
      disabled={isDisabled}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          size="small"
          InputLabelProps={{
            sx: {
              fontSize,
            },
          }}
          disabled={isDisabled}
        />
      )}
    />
  );
};

export default DeliveryUnitSelect;
